<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div class="col-12">

                        <h4 v-if="el.formTitle" class="mb-5">{{el.formTitle}}</h4>

                        <!-- Newsletter Form : Cyberimpact -->
                        <form
                            action=""
                            method="post"
                            target="_blank"
                            class="newsletter-form-body"
                            @submit="submitNewsletterForm"
                        >
                            <input type="email" name="email" id="email" placeholder="Votre adresse courriel" required="required">
                            <input type="submit" class="button" value="Envoyer">
                        </form>
                        <div class="form-success" v-if="formMessage">
                            <p>{{formMessage}}</p>
                        </div>
                    </div>
                </div>

                <div v-if="el.showSocials" class="row pt-5">
                    <div class="col-12">
                        <p>{{ $t('Vous pouvez aussi nous suivre sur les médias sociaux.') }}</p>
                        <SocialsIcons />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'
import { addNewMemberToCyberimpact } from '@/firebase/init'

import SocialsIcons from '@/components/Parts/SocialsIcons'

export default {
    name: 'newsletterForm',

    data() {
        return {
            err: '',
            formMessage: '',
        }
    },

    components: {
        // AssetLoader
        SocialsIcons,
    },
    props: {
        el: {
            type: Object,
            required: false,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        async submitNewsletterForm(event) {
            event.preventDefault()

            // Add member to CyberImpact
            const email = document.querySelector('#email').value

            try {
                await addNewMemberToCyberimpact({email})
                document.querySelector('#email').value = ''
                document.querySelector('.newsletter-form-body').classList.add('hide')
                this.formMessage = 'Merci pour votre inscription!'
            } catch (error) {
                this.err = error
                document.querySelector('#email').value = ''
                this.formMessage = 'Une erreur est survenue. Veuillez réessayer.'
            }
        }
    },
    // On loaded...
    mounted() {},
}
</script>
